import { useEffect, useState } from "react";
import { navigate } from 'wouter/use-browser-location';

interface RedirectAlertProps {
    seconds?: number;
    message?: string;
    to: string;
    /** Full page reload instead of SPA navigation (resets in-memory state). */
    reload?: boolean;
}

export default function RedirectAlert({
    seconds = 5,
    message = "You will be redirected shortly.",
    to,
    reload = false,
}: RedirectAlertProps) {

    const go = () => (reload ? window.location.assign(to) : navigate(to));
    const [countdown, setCountdown] = useState(seconds);

    useEffect(() => {
        // Countdown timer
        const interval = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        // Auto-redirect timer
        const timeout = setTimeout(() => {
            go();
        }, seconds * 1000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [navigate, seconds, to, reload]);

    return (
        <div className="p-4 border rounded-lg bg-yellow-50 text-yellow-800 shadow-md max-w-md mx-auto mt-8">
            <h2 className="font-semibold text-lg mb-1">Redirecting...</h2>
            <p className="text-sm mb-3">{message}</p>

            <div className="text-sm">
                Redirecting in <span className="font-bold">{countdown}</span> seconds...
            </div>

            <button
                onClick={go}
                className="mt-3 inline-block text-blue-600 underline text-sm hover:text-blue-800"
            >
                Go now
            </button>
        </div>
    );
}